import ThemeToggle from './components/ThemeToggle'

export default function Header() {
  return (
    <header
      id="header"
      className=""
    >
      <div
        className="container-responsive vertical-align:middle flex items-center justify-between py-4"
        id="brand"
      >
        <div className="flex items-center justify-end gap-3">
          <ThemeToggle />
        </div>
      </div>
    </header>
  )
}
